import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import "../BankDetailsModal.css";

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
    strokeLinecap="round" strokeLinejoin="round" width="22" height="22">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    <circle cx="12" cy="16" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const ZapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);

const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round" width="14" height="14">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    <polyline points="9 12 11 14 15 10" />
  </svg>
);

const BankDetailsModal = ({ show, onClose }) => {
  const history = useHistory();

  const handleAddBank = () => {
    onClose();
    history.push('/profile?bank=true');
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="fintech-modal"
    >
      <Modal.Body className="bank-modal-body">

        {/* ── Top gradient section ── */}
        <div className="bank-modal-top">
          <div className="bank-modal-top-bg" aria-hidden="true" />

          {/* Floating dots decoration */}
          <span className="bank-dot bank-dot--1" aria-hidden="true" />
          <span className="bank-dot bank-dot--2" aria-hidden="true" />
          <span className="bank-dot bank-dot--3" aria-hidden="true" />

          <div className="bank-icon-ring">
            <LockIcon />
          </div>

          <div className="bank-title">Verify Your Bank Account</div>
          <p className="bank-text">
            You're almost set! Please verify your bank details to enjoy seamless withdrawals on metal sell.
          </p>

          {/* Trust strip */}
          {/* <div className="bank-trust-strip">
            <span className="bank-trust-badge">
              <ShieldIcon />
              256-bit Encrypted
            </span>
            <span className="bank-trust-divider" />
            <span className="bank-trust-badge">
              RBI Regulated
            </span>
          </div> */}
        </div>

        {/* ── Bottom section ── */}
        <div className="bank-modal-bottom">

          {/* Feature pills */}
          <div className="bank-pills">
             <div className="bank-pill">
              <span className="bank-pill-icon"><ClockIcon /></span>
              <span>Instant<br />Verification</span>
            </div>

             <div className="bank-pill">
              <span className="bank-pill-icon"><ShieldIcon /></span>
              <span>100%<br />Secure</span>
            </div>

            <div className="bank-pill">
              <span className="bank-pill-icon"><ZapIcon /></span>
              <span>Faster<br />withdrawals</span>
            </div>
           
           
          </div>

          {/* Security note */}
          {/* <p className="bank-security-note">
            <ShieldIcon />
            Your data is protected by bank-grade encryption
          </p> */}

          {/* Actions */}
          <div className="bank-actions">
            <Button onClick={onClose} className="bank-btn-secondary">
              Later
            </Button>
            <Button onClick={handleAddBank} className="bank-btn-primary">
              <span className="" aria-hidden="true" />
              Add Bank Details
            </Button>
          </div>

        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BankDetailsModal;